// Autogenerated by `yarn version-file`. DO NOT EDIT
export var VERSION = '1.29.3';
//# sourceMappingURL=version.js.map